import React, { useState } from "react";
import { Check, ClipboardList, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { formatCdrStagingText } from "@/utils/cdrStagingBasket";

const CdrStagingAddButton = ({ record, onAdd, isDark, className = "" }) => {
  const [adding, setAdding] = useState(false);
  const [justAdded, setJustAdded] = useState(false);

  const handleClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (adding) return;
    setAdding(true);
    try {
      const result = onAdd(record);
      if (!result?.ok) {
        toast.error("Kayıt sepete eklenemedi");
        return;
      }
      const text = formatCdrStagingText(result.added || record);
      try {
        await navigator.clipboard.writeText(text);
      } catch {
        /* clipboard optional */
      }
      setJustAdded(true);
      toast.success(`CDR #${record.id} sepete eklendi`);
      window.setTimeout(() => setJustAdded(false), 1400);
    } finally {
      setAdding(false);
    }
  };

  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={handleClick}
      disabled={adding}
      className={`p-1.5 h-auto rounded-lg ${
        justAdded
          ? (isDark ? "text-emerald-400 bg-emerald-500/10" : "text-emerald-700 bg-emerald-50")
          : (isDark ? "text-violet-400 hover:text-violet-300 hover:bg-violet-500/10" : "text-violet-600 hover:text-violet-700 hover:bg-violet-50")
      } ${className}`}
      title="CDR bilgilerini sepete ekle (ses URL dahil)"
    >
      {adding ? (
        <Loader2 className="w-4 h-4 animate-spin" />
      ) : justAdded ? (
        <Check className="w-4 h-4" />
      ) : (
        <ClipboardList className="w-4 h-4" />
      )}
    </Button>
  );
};

export default CdrStagingAddButton;
